import React from 'react'
import { X } from 'lucide-react'

import { cn } from '@/lib/utils'
import { Progress } from '@/components/ui/progress'

export default function S3UploaderProgress({
  s3key,
  percentage,
  totalUploadTime,
  filename,
  totalBytes,
  uploadedBytes,
  timeLeftForUpload,
  status,
  errorMessage,
  abortCallback
}) {
  const indicatorClass = {
    UPLOADING: 'bg-primary',
    COMPLETE: 'bg-success',
    FAILED: 'bg-destructive',
    CANCELLED: 'bg-warning',
    QUEUED: 'bg-muted-foreground',
  }[status] || 'bg-primary'

  let label = ''
  if (status === 'UPLOADING') {
    label = `${uploadedBytes.value}${uploadedBytes.unit} / ${totalBytes.value}${totalBytes.unit}`
    if (uploadedBytes.value > 0 && uploadedBytes.value !== totalBytes.value) {
      label += ` · ${timeLeftForUpload} remaining`
    }
  } else if (status === 'FAILED') {
    label = errorMessage
  } else if (status === 'CANCELLED') {
    label = 'Cancelled'
  } else if (status === 'COMPLETE') {
    label = `${uploadedBytes.value}${uploadedBytes.unit} · Completed in ${totalUploadTime}`
  } else if (status === 'QUEUED') {
    label = `${totalBytes.value}${totalBytes.unit} · Queued`
  }

  const showAbort = (status === 'UPLOADING' || status === 'QUEUED') && percentage < 100

  return (
    <div>
      <div className="mb-1 flex items-center justify-between">
        <div className="min-w-0 flex-1">
          <div className="truncate text-sm font-medium">{filename}</div>
          <div className="text-xs text-muted-foreground">{label}</div>
        </div>
        {showAbort && (
          <button
            onClick={abortCallback}
            title="Cancel upload"
            className="ml-2 rounded p-1 text-muted-foreground hover:bg-accent hover:text-foreground"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
      <Progress
        value={percentage || 0}
        className="h-1.5"
        indicatorClassName={cn('transition-all', indicatorClass)}
      />
    </div>
  )
}
